<template>
  <div class="animated fadeIn parts--parts-list">
    <!-- <b-row id="parts-header-nav">
      <b-col md="6">
        <h1 id="parts-header-nav-txt">
          Parts List
          <records-count :total="pageInfo.totalItems" />
        </h1>
      </b-col>
      <b-col md="6" v-if="checkClaim(CAN_ADD_PARTS)">
        <div class="buttons-panel">
          <b-button @click="add()" size="sm" title="Add" style="float: right;margin-bottom: 5px;">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </b-button>
        </div>
      </b-col>
    </b-row> -->
    <fixed-header title="Parts" :records="pageInfo.totalItems" hideBackBtn hideNewOfferBtn>
      <template v-slot:center>
        <b-button size="sm" variant="primary" class="mr-3" @click="$router.push({ name: 'requirements.add.new', query: { partId: selectedRowItemId } })">
          <i class="fa fa-plus"></i>
          Add Requirement
        </b-button>
        <b-button v-if="checkClaim(CAN_ADD_OFFERS)" size="sm" variant="primary" @click="$bvModal.show('part-offer-modal')" class="mr-3">
          <i class="fa fa-plus"></i>
          New Offer
        </b-button>

        <add-quote v-if="checkClaim(CAN_ACCESS_QUOTES)" />

        <add-sales-order v-if="checkClaim(CAN_ADD_SALES_ORDER)" />

        <add-purchase-order v-if="checkClaim(CAN_ADD_POS)" />

        <add-crma v-if="checkClaim(CAN_ADD_RMAS)" :modalId="'toolbar-crma-modal'" class="mr-2" />

        <add-vrma v-if="checkClaim(CAN_ADD_VENDOR_RETURNS)" class="mr-2" />

        <add-offer v-if="checkClaim(CAN_ADD_OFFERS)" :modalId="'part-offer-modal'"/>
          
      </template>
    </fixed-header>
    <b-row>
      <b-col>
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-start align-items-end mb-2">
              <b-form-group label="Part Number" class="mr-2">
                <b-form-input v-model="filters.partNumber" @input="onSearch" size="sm" />
              </b-form-group>
              <b-form-group label="Manufacturer" class="mr-2">
                <b-form-input v-model="filters.manufacturer" @input="onSearch" size="sm" />
              </b-form-group>
              <b-form-group label="Warehouse" class="mr-2">
                <b-form-select v-model="selectedWarehouse" @change="onWarehouseChange">
                  <option
                    v-for="warehouse in sortSelect(warehouses)"
                    :key="warehouse.id"
                    :value="warehouse.id"
                  >{{warehouse.name}}</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label="Lot Code" class="mr-2">
                <b-form-input v-model="filters.lotCode" @input="onSearch" size="sm" />
              </b-form-group>
              <b-form-group label="Alternate PN" class="mr-2">
                <b-form-input v-model="filters.altPartNo" @input="onSearch" size="sm" />
              </b-form-group>
              <b-form-group label="Customer PN" class="mr-2">
                <b-form-input v-model="filters.customerPartNo" @input="onSearch" size="sm" />
              </b-form-group>
              <b-form-group label="Internal PN" class="mr-2">
                <b-form-input v-model="filters.internalPartNo" @input="onSearch" size="sm" />
              </b-form-group>
              <b-form-group label="NSN" class="mr-2">
                <b-form-input v-model="filters.NSN" @input="onSearch" size="sm" />
              </b-form-group>
              <b-button class="mr-2" size="sm" @click="onClear">Clear</b-button>
              <!-- <b-button size="sm" @click="onSearch">Search</b-button> -->
            </div>
            <grid-component
              isResizable
              isReorderable
              isSortable
              :canEdit="checkClaim(CAN_EDIT_PARTS)"
              :canDelete="checkClaim(CAN_DELETE_PARTS)"
              :gridId="gridId"
              :pageable="pageable"
              :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
              :take="pageInfo.pageSize"
              :itemData="itemData"
              :pageSizes="pageInfo.pageSize"
              :totalItems="pageInfo.totalItems"
              :fields="fields"
              :sortBy="pageInfo.sortBy"
              :sortOrder="pageInfo.sortOrder"
              :sortMethod="sortGrid"
              :onEdit="pushToDetails"
              :onDelete="onDelete"
              :handleRowClick="onRowClick"
              @getData="onGetData"
              :isTblLoader="tblLoader"
              :styleCustom="'height: 335px'"
              />
          </div>
        </div>
      </b-col>
    </b-row>
    <b-card>
      <lower-tab :partId="selectedRowItemId" @refresh-parts="onSearch"></lower-tab>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { debounce } from 'lodash';

import {
  GRID_PAGE_SIZES,
  GRID_ID,
} from '@/shared/constants';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';

import gridFields from './fields';
import LowerTab from './components/LowerTabs';
import FixedHeader from '@/shared/components/FixedHeader/indexNew';
import AddQuote from '@/pages/Quotes/components/AddQuote/index';
import AddSalesOrder from '@/pages/SalesOrders/components/add/index';
import AddPurchaseOrder from '@/pages/PurchaseOrders/components/add/index';
import AddInvoice from '@/pages/Invoices/components/add/index';
import AddCrma from '@/pages/Customerrmas/components/add/index';
import AddVrma from '@/pages/Vendorrmas/components/add/index';
import AddOffer from '@/shared/components/Offers/components/AddOffer';

const SEARCH_DEBOUNCE_TIME = 750;

export default {
  components: {
    GridSettings,
    GridComponent,
    LowerTab,
    FixedHeader,
    AddQuote,
    AddSalesOrder,
    AddPurchaseOrder,
    AddInvoice,
    AddCrma,
    AddVrma,
    AddOffer
  },
  metaInfo: () => ({
    title: 'Parts',
  }),
  data() {
    return {
      filtersVisible: false,
      fields: gridFields,
      gridId: GRID_ID.PARTS,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      selectedRowItemId: 0,
      selectedWarehouse: [],
      warehouses: [{ id: 1, name: 'Warehouse 1' }],
    };
  },
  computed: {
    // ...mapState('parts', [
    //   'filters',
    //   'lastOpenedId',
    // ]),
    ...mapGetters('lookup', ['manufacturers']),
    ...mapGetters('parts', [
      'partsList',
      'part',
      'pageInfo',
      'selectedItemId',
      'filters',
      'lastOpenedId',
      'tblLoader'
    ]),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      let data = [];
      if (this.partsList != undefined) {
        data = this.partsList.map(part => ({
          ...part,
          selected: part.id === this.selectedRowItemId,
        }));
      }
      return data;
    },
  },
  methods: {
    ...mapActions('parts', [
      'getAll',
      'getById',
      'sortGrid',
      'remove',
      'search',
      'select',
      'deletePart',
    ]),
    ...mapMutations('parts', [
      // 'setLastOpenedId',
      'setItem'
    ]),
    ...mapActions('account', ['saveGridSettings']),
    async onGetData(params) {
			await this.getAll(params);
			// this.skip = params.pageSize * (params.pageNumber - 1);
			// this.take = params.pageSize;
		},
    onSearch: debounce(function() {
      this.search(this.filters);
    }, SEARCH_DEBOUNCE_TIME),
    onClear(callSearch=true) {
      // this.clearFilters();
      // Object.keys(this.filters).forEach(filterName => {
      //   this.filters[filterName] = null;
      // });
      this.clearObject(this.filters);
      if(callSearch){this.search(this.filters);}
    },
    onWarehouseChange() {
      console.log('Warehouse change');
    },
    onRowClick: function(event) {
      this.edit(event.dataItem);
    },
    edit(item) {
      this.$router.push({ name: 'parts.edit', params: { id: item.id } });
    },
    add() {
      this.$router.push({ name: 'parts.add' });
    },
    onRowClick(row) {
      // this.setLastOpenedId(row.dataItem.id);
      this.setItem({
        resource: 'lastOpenedId',
        payload: row.dataItem.id
      });
      this.selectedRowItemId = row.dataItem.id;
      // const { id, detailsVisible } = row.dataItem;
      // this.select({ id, isChecked: !detailsVisible });
    },
    pushToDetails(row) {
      // this.setLastOpenedId(row.id);

      this.setItem({
        resource: 'lastOpenedId',
        payload: row.id
      });

      this.$router.push({
        name: 'parts.edit',
        params: { id: row.id },
      });
    },
    async onDelete(part) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete part #${part.id}?`});
      if (deleteConfirmed) {
        await this.deletePart(part.id);
        this.getAll({})
      }
		},
  },
  watch: {
    async partsList() {
    	//This function sets the first row as the selected row
      this.selectedRowItemId = await this.setSelectedRowId(this.partsList,this.selectedRowItemId,this.lastOpenedId);
      /*if (this.partsList.length > 0 && this.selectedRowItemId === 0 && !this.lastOpenedId) {
        this.setLastOpenedId(this.partsList[0].id);
    	  this.selectedRowItemId = this.partsList[0].id;
    	}
    	if(!this.partsList.length){
        this.setLastOpenedId(0);
        this.selectedRowItemId = 0;
      }*/
    },
  },
  async mounted() {
    if('clear' in this.$route.query) {
      this.pageInfo.pageNumber = 1;
      this.onClear(false);
      this.clearRoute();
    }else{
      if(this.lastOpenedId) {
        this.selectedRowItemId = this.lastOpenedId;
      }

      // this.skip = this.pageInfo.pageSize * (this.pageInfo.pageNumber - 1);
      // this.take = this.pageInfo.pageSize;

      // this.getAll({
      //   ...this.gridSettings.sort,
      //   pageSize: this.gridSettings.pageSize || this.take,
      // });

      this.setItem({
        resource: 'pageInfo',
        payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize}
      });
      await this.getAll({});
    }
  },
  beforeDestroy() {
    //this.select({ id: null, isChecked: false });
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

#parts-header-nav {
  width: 100%;
  z-index: 1000;
  position: fixed;
  border-bottom: 1px solid rgb(200, 206, 211);
  background: #fff;
}

#parts-header-nav-txt {
  background-color: #fff;
  padding: 8px;
  font-size: 20px;
  margin: 0px;
}

.parts {
  &--parts-list {
    .tools > * {
      margin: 0 0 0 3px;
    }

    .b-pagination {
      justify-content: center;
    }

    .create-ultra-rfp {
      margin-top: 0.5em;
      margin-bottom: 1em;
    }

    table td {
      cursor: pointer;
    }

    .buttons-panel {
      text-align: right;
      margin-right: 30px;
      margin-top: 7px;

      .btn {
        margin-left: 5px;
      }
    }

    .clear-filter-button-container {
      margin-top: 12px;
      text-align: right;
    }
  }

  &--grid-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.highlight {
  background: $rowSelection !important;
}

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

#KendoGrid .k-virtual-scrollable-wrap table {
  min-width: 800px;
}
</style>
